import { cn } from '@/shared/lib/utils';

/**
 * Figma 라이브러리 Page Control/number (789:10033) — 이미지 위 "1 / 6" 표시 (M-18 처방 이미지 상세)
 * 검정 30% 배경 · 알약형(radius 999) · 위아래 4 / 좌우 8 · 11 Regular 흰 글자
 */
export const PageControl = ({
  current,
  total,
  className,
}: {
  current: number;
  total: number;
  className?: string;
}) => (
  <span
    className={cn(
      'inline-flex items-center rounded-full bg-black/30 px-2 py-1 text-caption-11-r whitespace-nowrap text-fg-white',
      className,
    )}
    aria-label={`${total}장 중 ${current}번째`}
  >
    {current} / {total}
  </span>
);
